import React, { useContext } from 'react';
import { Select } from 'antd';
import MaiaTranslationContext from '$app/i18n/MaiaTranslationContext';
import { useMaiaT } from '$app/i18n/useMaiaT';
import { colors, getSiderChrome } from '$app/brand';
import config from '$config';
import {
  getTranslationSegmentsForApp,
  TRANSLATION_SEGMENT_LABELS,
} from '$app/i18n/segments';

const { foreground: siderForeground } = getSiderChrome();

/**
 * @param {{ block?: boolean }} props When `block` is set, renders full-width with a
 * label coloured for the sidebar chrome; otherwise inline for a light header.
 */
export default function LanguageSelector({ block = false }) {
  const t = useMaiaT();
  const { segment, setSegment } = useContext(MaiaTranslationContext);
  const isMotrio = config.segmentGroup === 'MOTRIO';
  const options = getTranslationSegmentsForApp(isMotrio);
  const labelColor = block ? siderForeground : colors.mutedText;

  return (
    <span
      style={{
        display: 'flex',
        flexDirection: block ? 'column' : 'row',
        alignItems: block ? 'stretch' : 'center',
        gap: block ? 4 : 8,
        width: block ? '100%' : undefined,
      }}
    >
      <span style={{ color: labelColor, fontSize: 13 }}>
        {t('maia.common.language', 'Language')}
      </span>
      <Select
        size="small"
        style={block ? { width: '100%' } : { minWidth: 160 }}
        value={segment}
        onChange={setSegment}
        dropdownMatchSelectWidth={false}
      >
        {options.map((value) => (
          <Select.Option key={value} value={value}>
            {TRANSLATION_SEGMENT_LABELS[value] || value}
          </Select.Option>
        ))}
      </Select>
    </span>
  );
}
